module.exports = __webpack_public_path__ + "static/media/vin_health.55bfd8b4.svg";